import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFastDelivery: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"fast-delivery, quick-commerce"} maskId="square-filled-radius-0-stroke-1-IconFastDelivery"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H12V20H20V4H16V10H8V4H4V11H3V3ZM3 14H9V15H3V14ZM1 17H7V18H1V17ZM3 20H9V21H3V20Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFastDelivery;
